[
  {
    "code": "VE-Z",
    "name": "Amazonas"
  },
  {
    "code": "VE-B",
    "name": "Anzoátegui"
  },
  {
    "code": "VE-C",
    "name": "Apure"
  },
  {
    "code": "VE-D",
    "name": "Aragua"
  },
  {
    "code": "VE-E",
    "name": "Barinas"
  },
  {
    "code": "VE-F",
    "name": "Bolívar"
  },
  {
    "code": "VE-G",
    "name": "Carabobo"
  },
  {
    "code": "VE-H",
    "name": "Cojedes"
  },
  {
    "code": "VE-Y",
    "name": "Delta Amacuro"
  },
  {
    "code": "VE-W",
    "name": "Dependencias Federales"
  },
  {
    "code": "VE-A",
    "name": "Distrito Capital"
  },
  {
    "code": "VE-I",
    "name": "Falcón"
  },
  {
    "code": "VE-J",
    "name": "Guárico"
  },
  {
    "code": "VE-K",
    "name": "Lara"
  },
  {
    "code": "VE-M",
    "name": "Miranda"
  },
  {
    "code": "VE-N",
    "name": "Monagas"
  },
  {
    "code": "VE-L",
    "name": "Mérida"
  },
  {
    "code": "VE-O",
    "name": "Nueva Esparta"
  },
  {
    "code": "VE-P",
    "name": "Portuguesa"
  },
  {
    "code": "VE-R",
    "name": "Sucre"
  },
  {
    "code": "VE-T",
    "name": "Trujillo"
  },
  {
    "code": "VE-S",
    "name": "Táchira"
  },
  {
    "code": "VE-X",
    "name": "Vargas"
  },
  {
    "code": "VE-U",
    "name": "Yaracuy"
  },
  {
    "code": "VE-V",
    "name": "Zulia"
  }
]